import ExternalLogger from "../../../logger/ExternalLogger";

var LanguageModalController = function (
    $rootScope,
    $scope,
    $window,
    $modalInstance,
    LanguageCodeFactory
) {
    var vm = this;

    /**
     * Logger.
     */
    var logger = ExternalLogger.getInstance("LanguageModalController");

    /**
     *  Close modal window
     **/
    $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
    };

    function init() {
        logger.debug("init()");
        $scope.trnsltWbTrnCode = $rootScope.trnsltWbTrnCode;
        $scope.langUpdTrnCode = $rootScope.langUpdTrnCode;
        if (
            $rootScope.siteContactInfo.selectedLanguage &&
            $rootScope.siteContactInfo.selectedLanguage === "SPN"
        ) {
            $scope.selectedLanguage = "ENG";
        } else {
            $scope.selectedLanguage = "SPN";
        }
    }

    /**
     *
     * @param {*} fromLangCode  e.g. en
     * @param {*} toLangCode  e.g. el
     * Usage:
     *  redirectToPreferredLanguageSite('en','es');
     *  redirectToPreferredLanguageSite('es','en');
     */
    function redirectToPreferredLanguageSite(selectedLanguage) {
        var currentUrl = $window.location.href;
        var https = "https://";
        var http = "http://";
        var period = ".";
        var newUrl = currentUrl;
        var toLangCode = "es";
        if (selectedLanguage === "SPN") {
            // prepend domain part for the url with language code
            // E.g. https://proj9.retirementpartner.com/participant/home/#/dashboard/retirement-income
            // Will be changed to
            // https://es.proj9.retirementpartner.com/participant/home/#/dashboard/retirement-income
            if (
                currentUrl.indexOf(https + toLangCode) < 0 &&
                currentUrl.indexOf(http + toLangCode) < 0
            ) {
                newUrl = currentUrl.replace(https, https + toLangCode + period);
                newUrl = newUrl.replace(http, http + toLangCode + period);
            }
        } else {
            newUrl = currentUrl.replace(https + toLangCode + period, https);
            newUrl = newUrl.replace(http + toLangCode + period, http);
        }

        $window.location.href = vm.updateQueryStringParameter(newUrl);
    }

    vm.updateQueryStringParameter = function (uri) {
        var key = "accu";
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + $window.accu + "$2");
        } else {
            return uri + separator + key + "=" + $window.accu;
        }
    };

    /**
     *  Save language code
     **/
    $scope.save = function () {
        var isLanguageChanged = true;
        var updateLanguageCodeData = {
            selectedLanguage: this.selectedLanguage
        };
        if (this.selectedLanguage === $rootScope.siteContactInfo.selectedLanguage) {
            isLanguageChanged = false;
        }
        LanguageCodeFactory.updateLanguageCode.query(
            updateLanguageCodeData,
            function (data) {
                if (
                    data !== null &&
                    data.languageCode &&
                    data.languageCode === updateLanguageCodeData.selectedLanguage &&
                    $modalInstance
                ) {
                    $modalInstance.close(updateLanguageCodeData.selectedLanguage);
                    if ($rootScope.trnsltWbTrnCode && isLanguageChanged) {
                        redirectToPreferredLanguageSite(updateLanguageCodeData.selectedLanguage);
                    }
                } else {
                    logger.error(
                        "Failed to update language code of selectedLanguageCode=%s",
                        updateLanguageCodeData.selectedLanguage,
                        data
                    );
                    $modalInstance.dismiss("cancel");
                }
            },
            function (error) {
                logger.error(
                    "Failed to update language code of selectedLanguageCode=%s",
                    updateLanguageCodeData.selectedLanguage,
                    error
                );
            }
        );
    };

    function closeModal(data) {
        if ($modalInstance) {
            $modalInstance.close(data.selectedLanguage);
        }
    }

    init();
};

LanguageModalController.$inject = [
    "$rootScope",
    "$scope",
    "$window",
    "$modalInstance",
    "LanguageCodeFactory"
];
export default LanguageModalController;
